import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { NetworkError } from "../Error";

const NetworkStatusWrapper = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const isInterviewPath = (pathname: string) => {
      return pathname.includes("/interview-round");
    };

    const handleOnline = () => {
      setIsOffline(false);

      if (!isInterviewPath(window.location.pathname)) {
        window.location.reload();
      }
    };

    const handleOffline = () => {
      setIsOffline(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    const isInterviewPath = (pathname: string) => {
      return (
        pathname.includes("/interview-round") ||
        pathname.includes("/online-interview")
      );
    };

    if (!isInterviewPath(location.pathname) && !navigator.onLine) {
      setIsOffline(true);
    }
  }, [location.pathname]);

  const isCurrentPathInterview = location.pathname.includes("/interview-round");
  const shouldShowOffline = isOffline && !isCurrentPathInterview;

  return <>{shouldShowOffline ? <NetworkError /> : children}</>;
};

export default NetworkStatusWrapper;